import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
export function Header() {
  return <header className="bg-blue-900 text-white w-full py-3" data-id="element-22">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 flex justify-between items-center" data-id="element-23">
        <div className="font-bold text-lg" data-id="element-24">KneeRelief</div>
        <nav className="flex items-center space-x-4" data-id="element-25">
          <a href="#order" className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded flex items-center text-sm font-medium" data-id="element-26">
            Order Now <ChevronRightIcon className="h-4 w-4 ml-1" data-id="element-27" />
          </a>
        </nav>
      </div>
    </header>;
}